import { executeStatefulServerSideGuards } from '../helper/executeServerSideGuards';
import { generateInitialServerSideGuards } from './status-board/generateInitialServerSideGuards';
import { INITIAL_DEFAULT_STATE } from './status-board/state';

import type { GetServerSidePropsContext } from 'next';
import type { GetServerSidePropsWrapperProps } from '../../types';

/**
 * Status GSSP 래퍼
 */
export const getServerSidePropsStatusWrapper = (props?: GetServerSidePropsWrapperProps) => {
  const { serviceInitialGuards = [] } = props ?? {};

  const initialGuards = generateInitialServerSideGuards(serviceInitialGuards);

  return async (context: GetServerSidePropsContext) => {
    return await executeStatefulServerSideGuards({
      context,
      guards: initialGuards,
      state: INITIAL_DEFAULT_STATE,
    });
  };
};
